module.exports = __webpack_public_path__ + "static/6-formation-deformation-s-vi-bc7bac4c857b27089fcd8a7b5d103f4a.jpg";